export default "__VITE_ASSET__OTUkHbCq__"